// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

type AdChoicesProps = {
  width?: number;
  height?: number;
};

export function AdChoices({ width = 24, height = 24 }: AdChoicesProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
    >
      <path
        d="M.594.695l-.594.7v10.707c0 10.488.008 10.718.477 11.3.73.914 1.933.82 4.039-.324.933-.508 1.8-1.113 1.925-1.344.407-.746.266-1.55-.336-1.937-.48-.309-.699-.324-1.421-.09-.79.258-.891.238-1.274-.23-.387-.465-.422-1.079-.422-7.563 0-6.023.055-7.133.36-7.562.199-.278.562-.504.816-.504.504 0 12.707 6.804 13.414 7.48.848.809.258 1.332-3.883 3.457-2.105 1.086-3.851 1.969-3.875 1.969-.023 0-.011-.996.028-2.215.062-1.98.02-2.281-.422-2.832-.586-.734-1.371-.789-1.973-.137-.39.426-.437.856-.437 4.059 0 3.476.015 3.598.558 4.164.348.367.805.586 1.219.586.785 0 12.71-6.29 13.613-7.176l.586-.578.067 5.066c.035 2.786.066.172.066-5.804 0-5.977-.031-8.582-.066-5.793l-.067 5.078-.629-.586C22.02 10.262 17.547 7.75 12.426 5 2.012-.594 1.773-.68.594.695M.105 12.113c0 5.977.032 8.39.067 5.364.035-3.032.035-7.922 0-10.872-.035-2.949-.067-.468-.067 5.508m7.407-4c-.692.75-.301 2.239.613 2.328 1.445.145 2.223-1.093 1.406-2.238-.441-.625-1.488-.668-2.02-.09"
        fillRule="evenodd"
        fill="#04accc"
      />
    </svg>
  );
}
